<a class="notification-link" (click)="downloadFile()">
  {{ 'User::ClickHereToDownloadUserListReport' | abpLocalization }}
</a>
